import { Component, OnInit, OnDestroy, Input, Output, Inject, EventEmitter } from '@angular/core';
import { ISubscription } from "rxjs/Subscription";
import { Observable } from 'rxjs/Rx';

import { SearchResultItem } from '../search-result-item';


export class NavSearchEmployeeResultTypeComponent implements OnInit, OnDestroy {

  
  public result : SearchResultItem;

  constructor() { }

  ngOnInit() {


  }

  ngOnDestroy() {

  }



static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[leaf-nav-employee-search-result]',
  template: `
    <style>
    </style>
    <span style="display: table-cell; vertical-align: top; width: 1px; padding-right: 10px;">
      <img alt="image" class="img-circle" src="http://10.129.100.30/rest/user/{{result.id}}/photo?square=true" width="40" height="40">
    </span>
    <span style="display: table-cell; vertical-align: top;">
      <strong>{{result.title}}</strong><br/>
      <small>{{result.text}}</small>
    </span>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'result': [{ type: Input, args: ['leaf-nav-employee-search-result', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
